<template>
    <div>
        <div class="flex h-screen-header overflow-y-auto">
            <ul class="menu bg-base-100 w-16 md:w-56 my-2 rounded-box">
                <li>
                    <a :class="{ 'active': activeIndex === 1 }" @click="handleActive(1)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                        </svg>
                        <div class="!hidden md:!block">基本设置</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 2 }" @click="handleActive(2)">
                        <svg t="1709776900830" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="10126" width="200" height="200">
                            <path
                                d="M304.697598 824.441653a291.891313 291.891313 0 1 1 291.891313-291.891313 292.48701 292.48701 0 0 1-291.891313 291.891313zM304.697598 298.441593a232.321658 232.321658 0 1 0 232.321657 232.321657A232.917354 232.917354 0 0 0 304.697598 298.441593z"></path>
                            <path
                                d="M304.697598 674.921817a142.371477 142.371477 0 1 1 141.775781-142.371477 142.371477 142.371477 0 0 1-141.775781 142.371477z m0-224.577602a82.801822 82.801822 0 1 0 82.206125 82.206125A82.801822 82.801822 0 0 0 304.697598 450.344215zM53.909347 677.304603l58.378263-12.509627 74.34293 346.754966-58.378263 12.509628zM537.9128 541.307079l56.769882-17.990036 143.562871 452.550675-56.769882 17.990036zM192.587506 262.401951l494.070725-193.89923 21.742924 55.39978-494.070725 193.958799z"></path>
                            <path
                                d="M548.456629 531.001529l283.84941-218.14408 36.33749 47.238737L584.67498 578.240266z"></path>
                            <path
                                d="M828.910569 365.755304a182.878843 182.878843 0 1 1 110.799559-327.633107 29.784828 29.784828 0 0 1 11.318235 26.210648 28.593435 28.593435 0 0 1-16.083807 23.827863l-69.100801 36.33749 26.806345 51.229904L965.920777 137.603522a27.997738 27.997738 0 0 1 27.402042 0 29.189131 29.189131 0 0 1 16.083807 22.636469v23.232166a182.283147 182.283147 0 0 1-180.496057 182.283147z m0-305.592334a123.309187 123.309187 0 1 0 119.139311 154.285408l-54.208386 27.997738a29.784828 29.784828 0 0 1-22.63647 0 28.593435 28.593435 0 0 1-17.2752-14.892414l-54.208387-104.246897a29.189131 29.189131 0 0 1 12.509628-39.91167l42.890152-22.040772A131.053243 131.053243 0 0 0 828.910569 60.16297z"></path>
                        </svg>
                        <div class="!hidden md:!block">后台刮削</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 3 }" @click="handleActive(3)">
                        <svg t="1709776996533" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="11137" width="200" height="200">
                            <path
                                d="M837.864727 560.593455l-14.289454 46.754909a324.724364 324.724364 0 0 1-23.877818 57.460363l-23.016728 43.194182 32.791273 36.352a46.312727 46.312727 0 0 1-1.256727 63.860364 45.451636 45.451636 0 0 1-32.395637 13.265454c-11.682909 0-22.853818-4.258909-31.464727-12.008727l-36.352-32.814545-43.217454 23.04c-18.455273 9.844364-37.794909 17.873455-57.437091 23.877818l-46.754909 14.289454-2.56 48.826182A46.336 46.336 0 0 1 512 930.909091a46.336 46.336 0 0 1-46.033455-44.218182l-2.56-48.826182-46.754909-14.289454a324.491636 324.491636 0 0 1-57.437091-23.877818l-43.217454-23.04-36.352 32.814545c-8.587636 7.749818-19.781818 12.032-31.464727 12.032-12.334545 0-23.831273-4.724364-32.395637-13.288727a46.312727 46.312727 0 0 1-1.256727-63.860364l32.791273-36.352-23.016728-43.217454a323.770182 323.770182 0 0 1-23.877818-57.437091l-14.289454-46.778182-48.826182-2.56A46.359273 46.359273 0 0 1 93.090909 512c0-24.529455 19.432727-44.730182 44.218182-46.033455l48.826182-2.56 14.289454-46.778181c6.004364-19.618909 14.033455-38.935273 23.877818-57.413819l23.016728-43.217454-32.791273-36.352a46.312727 46.312727 0 0 1 1.256727-63.860364 45.451636 45.451636 0 0 1 32.395637-13.288727c11.682909 0 22.877091 4.282182 31.464727 12.032l36.352 32.791273 43.217454-23.04a325.236364 325.236364 0 0 1 57.437091-23.854546l46.754909-14.289454 2.56-48.826182A46.359273 46.359273 0 0 1 512 93.090909c24.529455 0 44.730182 19.432727 46.033455 44.218182l2.56 48.826182 46.754909 14.289454c19.642182 6.004364 38.981818 14.033455 57.437091 23.877818l43.217454 23.016728 36.352-32.814546c8.610909-7.726545 19.781818-12.008727 31.464727-12.008727 12.334545 0 23.831273 4.724364 32.395637 13.265455a46.312727 46.312727 0 0 1 1.256727 63.860363l-32.791273 36.375273 23.016728 43.217454c9.844364 18.478545 17.873455 37.794909 23.877818 57.437091l14.289454 46.754909 48.826182 2.56c24.808727 1.303273 44.218182 21.504 44.218182 46.033455a46.336 46.336 0 0 1-44.218182 46.033455l-48.826182 2.56zM1000.727273 512c0-61.952-49.198545-112.546909-110.382546-115.758545a393.658182 393.658182 0 0 0-29.021091-69.841455c41.076364-45.544727 40.075636-116.154182-3.746909-159.976727a115.2 115.2 0 0 0-81.757091-33.745455 116.596364 116.596364 0 0 0-78.219636 29.998546 394.682182 394.682182 0 0 0-69.841455-29.021091C624.546909 72.448 573.952 23.272727 512 23.272727c-61.952 0-112.546909 49.198545-115.758545 110.382546a395.403636 395.403636 0 0 0-69.841455 29.021091 116.596364 116.596364 0 0 0-78.219636-30.021819 115.2 115.2 0 0 0-81.757091 33.745455c-43.822545 43.845818-44.8 114.455273-3.746909 160a395.403636 395.403636 0 0 0-29.021091 69.818182C72.471273 399.476364 23.272727 450.071273 23.272727 512c0 61.952 49.198545 112.570182 110.382546 115.758545a393.937455 393.937455 0 0 0 29.021091 69.818182c-41.053091 45.568-40.075636 116.177455 3.746909 160a115.2 115.2 0 0 0 81.757091 33.745455 116.596364 116.596364 0 0 0 78.219636-30.021818c22.132364 11.799273 45.474909 21.597091 69.841455 29.044363C399.453091 951.528727 450.048 1000.727273 512 1000.727273c61.952 0 112.546909-49.198545 115.758545-110.382546 24.389818-7.447273 47.709091-17.245091 69.841455-29.021091a116.596364 116.596364 0 0 0 78.219636 29.998546 115.2 115.2 0 0 0 81.757091-33.745455c43.822545-43.822545 44.8-114.432 3.746909-159.976727 11.776-22.109091 21.573818-45.451636 29.021091-69.841455C951.528727 624.570182 1000.727273 573.952 1000.727273 512z m-316.485818 34.909091c-14.289455 0-26.88 8.843636-32.279273 22.085818-22.551273 55.226182-76.730182 94.254545-139.962182 94.254546s-117.410909-39.028364-139.962182-94.254546a34.955636 34.955636 0 0 0-32.279273-22.109091c-24.343273 0-41.844364 24.576-32.791272 47.173818C339.595636 675.444364 419.095273 733.090909 512 733.090909c92.904727 0 172.404364-57.646545 205.032727-139.031273 9.053091-22.597818-8.448-47.150545-32.791272-47.150545z m-344.48291-69.818182c14.289455 0 26.88-8.843636 32.279273-22.109091 22.551273-55.202909 76.730182-94.254545 139.962182-94.254545s117.410909 39.051636 139.962182 94.254545c5.399273 13.265455 17.989818 22.109091 32.279273 22.109091 24.343273 0 41.844364-24.552727 32.791272-47.150545C684.404364 348.578909 604.904727 290.909091 512 290.909091c-92.904727 0-172.404364 57.669818-205.032727 139.031273-9.053091 22.574545 8.448 47.150545 32.791272 47.150545z"></path>
                        </svg>
                        <div class="!hidden md:!block">其他设置</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 4 }" @click="handleActive(4)">
                        <svg t="1709777080693" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="12709" width="200" height="200">
                            <path
                                d="M768 0a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128h512z m0 64H256a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64z m-32 768v64h-448v-64h448zM512 256a256 256 0 1 1 0 512 256 256 0 0 1 0-512z m0 64a192 192 0 1 0 0 384 192 192 0 0 0 0-384z m0 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM320 128v64H256V128h64z m448 0v64H704V128h64z"></path>
                        </svg>
                        <div class="!hidden md:!block">小爱音响</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 5 }" @click="handleActive(5)">
                        <svg t="1709776761281" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="6779" width="200" height="200">
                            <path
                                d="M746.666667 725.333333c59.733333-12.8 106.666667-64 106.666666-128 0-72.533333-55.466667-128-128-128-17.066667 0-29.866667 4.266667-42.666666 8.533334V469.333333c0-93.866667-76.8-170.666667-170.666667-170.666666s-170.666667 76.8-170.666667 170.666666c0 17.066667 4.266667 29.866667 4.266667 46.933334-8.533333-4.266667-17.066667-4.266667-25.6-4.266667C260.266667 512 213.333333 558.933333 213.333333 618.666667S260.266667 725.333333 320 725.333333h426.666667z m0 85.333334h-426.666667C213.333333 810.666667 128 725.333333 128 618.666667c0-85.333333 55.466667-157.866667 128-183.466667C273.066667 311.466667 379.733333 213.333333 512 213.333333c110.933333 0 209.066667 72.533333 243.2 170.666667 102.4 12.8 183.466667 102.4 183.466667 213.333333s-85.333333 200.533333-192 213.333334z"></path>
                        </svg>
                        <div class="!hidden md:!block">网盘音乐</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 7 }" @click="handleActive(7)">
                        <svg t="1736670858037" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2455" width="200" height="200"><path d="M512 640a32 32 0 0 0-32 32v96a32 32 0 1 0 64 0v-96a32 32 0 0 0-32-32zM333.312 317.888a12.8 12.8 0 0 0 9.056 3.744H480V544a32 32 0 1 0 64 0v-222.368h139.904a12.8 12.8 0 0 0 9.056-21.856l-170.752-170.752a12.8 12.8 0 0 0-18.112 0l-170.752 170.752a12.8 12.8 0 0 0-0.032 18.112z" p-id="2456"></path><path d="M892.384 186.496l-174.176-86.08a32.032 32.032 0 0 0-28.384 57.376L864 243.872v502.848l-352 147.52-352-147.52V243.872l174.176-86.08a32 32 0 0 0-28.32-57.376l-174.208 86.08A63.648 63.648 0 0 0 96 243.872v502.848c0 25.888 15.424 49.056 39.264 59.008l364.384 152.704a31.936 31.936 0 0 0 24.768 0l364.352-152.672A63.84 63.84 0 0 0 928 746.72V243.872a63.68 63.68 0 0 0-35.616-57.376z" p-id="2457"></path></svg>
                        <div class="!hidden md:!block">开放 API</div>
                    </a>
                </li>
                <li>
                    <a :class="{ 'active': activeIndex === 6 }" @click="handleActive(6)">
                        <svg t="1726906083184" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="1518" width="200" height="200">
                            <path
                                d="M959.825022 191.939717C959.825022 121.2479 902.517291 63.940169 831.825474 63.940169H191.939717C121.2479 63.940169 63.940169 121.2479 63.940169 191.939717v639.885757C63.940169 902.517291 121.2479 959.825022 191.939717 959.825022h639.885757c70.691817 0 127.999548-57.307731 127.999548-127.999548V191.939717zM146.715595 146.66502a63.839021 63.839021 0 0 1 45.372232-18.784682h639.824346A64.037705 64.037705 0 0 1 895.884854 192.001129V480.093133s0.0289 0 0 0h-50.527184l-54.764574-54.710387a31.970084 31.970084 0 0 0-52.933067 12.506263L698.078535 556.676838l-93.482694-186.965389a31.970084 31.970084 0 0 0-58.279477 2.423947l-93.269561 233.168483-102.307883-358.086621a31.970084 31.970084 0 0 0-59.330697-5.519807l-119.264671 238.269247L127.880338 480.093133V192.001129A63.777609 63.777609 0 0 1 146.715595 146.66502z m730.43515 730.536299a63.456102 63.456102 0 0 1-45.253022 18.67631H192.087827c-17.112123 0-33.270563-6.574639-45.372232-18.67631S127.880338 849.110994 127.880338 831.998871V544.033302l64.135241-0.180622a32.024271 32.024271 0 0 0 28.538267-17.668439l91.261045-182.395653L417.236696 712.781162a31.977309 31.977309 0 0 0 29.112645 23.144896q0.823636 0.043349 1.64366 0.043349a31.973697 31.973697 0 0 0 29.676186-20.095998l101.560108-253.900269 96.163124 192.322635a31.970084 31.970084 0 0 0 58.926104-4.186816l47.651681-142.951433 27.552072 27.523172a31.970084 31.970084 0 0 0 22.60303 9.352604H895.884854c0.0289 0 0 0 0 0v287.965569a63.398303 63.398303 0 0 1-18.719659 45.209673z"
                                fill="" p-id="1519"></path>
                        </svg>
                        <div class="!hidden md:!block">系统信息</div>
                    </a>
                </li>
            </ul>
            <div class="flex-1 mx-2 my-2 rounded-2xl bg-base-100 p-8 overflow-y-auto">
                <div v-if="activeIndex === 1">
                    <div class="mb-4">
                        <div class="mb-1">本地音乐标签写入位置:</div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_metadata"
                                       @change="HandleUpdateSys('save_in_metadata')"/>
                                <span class="label-text">元数据</span>
                            </label>
                        </div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_db"
                                       @change="HandleUpdateSys('save_in_db')"/>
                                <span class="label-text">音乐收藏</span>
                            </label>
                        </div>
                        <div class="text-gray-400 text-sm">元数据：内嵌进音乐文件中。音乐收藏: 音乐标签提供的数据库</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">webdav音乐标签写入位置:</div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_metadata_wb"
                                       @change="HandleUpdateSys('save_in_metadata_wb')"/>
                                <span class="label-text">元数据</span>
                            </label>
                        </div>
                        <div class="form-control w-32">
                            <label class="label cursor-pointer">
                                <input type="checkbox" class="checkbox" v-model="formData.save_in_db_wb"
                                       @change="HandleUpdateSys('save_in_db_wb')"/>
                                <span class="label-text">音乐收藏</span>
                            </label>
                        </div>
                        <div class="text-gray-400 text-sm">元数据：内嵌进音乐文件中。音乐收藏: 音乐标签提供的数据库</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">文件显示数量:</div>
                        <input type="number" min="0"
                               placeholder="请输入"
                               v-model="formData.file_list_limit"
                               @change="HandleUpdateSys('file_list_limit')"
                               class="input input-sm input-bordered w-full max-w-xs"/>
                        <div class="text-gray-400 text-sm">操作台单个目录下的文件夹显示限制，默认为 5000</div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">音乐记录Last.fm:</div>
                        <div class="p-2 rounded-xl bg-base-200">
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">开启记录:</div>
                                <input type="checkbox" class="toggle toggle-md" v-model="formData.is_record_lastfm"
                                       @change="HandleUpdateSys('is_record_lastfm')"/>
                                <div class="text-gray-400 text-sm flex">
                                    将您的Subsonic帐户连接到
                                    <div class="underline cursor-pointer" @click="HandleOpenLastfm">您的Last.fm 帐户</div>
                                    ，通过任何设备或平台上的播放记录您所听的一切内容。
                                </div>
                            </div>
                            <input type="password" name="password1"  style="display:none"/>
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">用户名:</div>
                                <input type="text" min="0" placeholder="请输入"
                                       v-model="formData.lastfm_user"
                                       autocomplete="new-password"
                                       @change="HandleUpdateSys('lastfm_user')"
                                       class="input input-sm input-bordered w-full max-w-xs"/>
                            </div>
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">密码:</div>
                                <input type="password" min="0" placeholder="请输入"
                                       v-model="formData.lastfm_pass"
                                       autocomplete="new-password"
                                       @change="HandleUpdateSys('lastfm_pass')"
                                       class="input input-sm input-bordered w-full max-w-xs"/>
                            </div>
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">API Key:</div>
                                <input type="password" min="0" placeholder="请输入"
                                       v-model="formData.lastfm_api_key"
                                       @change="HandleUpdateSys('lastfm_api_key')"
                                       class="input input-sm input-bordered w-full max-w-xs"/>
                            </div>
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">API Secret:</div>
                                <input type="password" min="0" placeholder="请输入"
                                       v-model="formData.lastfm_api_secret"
                                       @change="HandleUpdateSys('lastfm_api_secret')"
                                       class="input input-sm input-bordered w-full max-w-xs"/>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">播放时转码:</div>
                        <div class="p-2 rounded-xl">
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">开启转码:</div>
                                <input type="checkbox" class="toggle toggle-md" v-model="formData.is_play_decode"
                                       @change="HandleUpdateSys('is_play_decode')"/>
                                <div class="text-gray-400 text-sm">播放前会将音乐解码为特定格式，但不是实时转码会耗费时间。</div>
                            </div>
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">缓存文件数:</div>
                                <input type="number" min="0" placeholder="请输入"
                                       v-model="formData.decode_cache_num"
                                       @change="HandleUpdateSys('decode_cache_num')"
                                       class="input input-sm input-bordered w-full max-w-xs"/>
                            </div>
                            <div class="flex flex-col mt-1">
                                <div class="text-sm">转码命令:</div>
                                <input type="text" min="0" placeholder="请输入"
                                       v-model="formData.decode_command"
                                       @change="HandleUpdateSys('decode_command')"
                                       class="input input-sm input-bordered w-full max-w-xs"/>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="mb-1">配置管理:</div>
                        <button class="btn btn-sm btn-neutral mr-2" @click="handleExportConfig">导出配置</button>
                        <button class="btn btn-sm" onclick="import_config.showModal()">导入配置</button>
                        <div class="text-gray-400 text-sm">导出系统设置中的所有配置项，方便备份和转移</div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 2">
                    <div class="mb-2">
                        <div class="mb-1">开启后台刮削:</div>
                        <input type="checkbox" class="toggle toggle-md mb-1" v-model="formData.is_watch_file"
                               @change="HandleUpdateSys('is_watch_file')"/>
                    </div>
                    <div class="mb-4 flex">
                        <div>
                            <div class="mb-1 flex items-center">
                                后台刮削目录:
                                <div class="dropdown">
                                    <div tabindex="0" role="button" class="btn btn-circle btn-ghost btn-xs text-info">
                                        <svg t="1733581136651"
                                             class="icon h-5 w-5 cursor-pointer" viewBox="0 0 1024 1024" version="1.1"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M512 97.52381c228.912762 0 414.47619 185.563429 414.47619 414.47619s-185.563429 414.47619-414.47619 414.47619S97.52381 740.912762 97.52381 512 283.087238 97.52381 512 97.52381z m0 73.142857C323.486476 170.666667 170.666667 323.486476 170.666667 512s152.81981 341.333333 341.333333 341.333333 341.333333-152.81981 341.333333-341.333333S700.513524 170.666667 512 170.666667z m45.32419 487.619047v73.142857h-68.510476l-0.024381-73.142857h68.534857z m-4.047238-362.008381c44.251429 8.923429 96.889905 51.126857 96.889905 112.518096 0 61.415619-50.151619 84.650667-68.120381 96.134095-17.993143 11.50781-24.722286 24.771048-24.722286 38.863238V609.52381h-68.534857v-90.672762c0-21.504 6.89981-36.571429 26.087619-49.883429l4.315429-2.852571 38.497524-25.6c24.551619-16.530286 24.210286-49.712762 9.020952-64.365715a68.998095 68.998095 0 0 0-60.391619-15.481904c-42.715429 8.387048-47.640381 38.521905-47.932952 67.779047v16.554667H390.095238c0-56.953905 6.534095-82.773333 36.912762-115.395048 34.03581-36.449524 81.993143-42.300952 126.268952-33.328762z"
                                                p-id="2412"></path>
                                        </svg>
                                    </div>
                                    <div
                                        tabindex="0"
                                        class="card compact dropdown-content bg-base-100 rounded-box z-[1] w-96 shadow">
                                        <div tabindex="0" class="card-body">
                                            <h2 class="card-title">帮助提示？</h2>
                                            <div class="ml-2 text-gray-400 border rounded-xl p-4">
                                                <div>
                                                    /app/download: 部署Docker应用时，需额外映射一个自定义目录到此路径，用于存放下载的文件。
                                                </div>
                                                <div>
                                                    /app/media/download: 既然部署时已映射了/app/media，只需在该路径下创建一个名为download的目录，无需再次映射。
                                                </div>
                                                <div class="mt-1">ps. 两个目录只需创建一个即可。</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="badge badge-outline mb-1 mr-1 cursor-pointer"
                                 @click="redirctEditDetail('/app/download/')">/app/download/
                            </div>
                            <div class="badge badge-outline mb-1 cursor-pointer"
                                 @click="redirctEditDetail('/app/media/download/')">/app/media/download/
                            </div>
                            <div class="text-gray-400 text-sm">后台刮削的监控目录，会对该目录下新增的音乐文件进行以下一系列操作，每 3 分钟扫描一次。</div>
                        </div>
                    </div>
                    <div class="collapse collapse-arrow bg-base-100 max-w-2xl">
                        <input type="checkbox" v-model="preDataCollapse"/>
                        <div class="collapse-title text-xl font-medium">音乐预处理</div>
                        <div class="collapse-content">
                            <div>
                                <div class="space-y-2 max-w-xl">
                                    <label
                                        for="Option1"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="checkbox" class="checkbox size-4 rounded border-gray-300"
                                                   id="Option1" v-model="formData.is_voiceprint"
                                                   @change="HandleUpdateSys('is_voiceprint')"/>
                                        </div>

                                        <div>
                                            <strong class="font-medium text-base-600"> 声纹识别 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                当音乐文件缺少艺术家或专辑元数据时, 使用声纹识别进行预匹配.
                                            </p>
                                        </div>
                                    </label>

                                    <label
                                        for="Option2"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="checkbox" class="checkbox size-4 rounded border-gray-300"
                                                   id="Option2" v-model="formData.is_fix_encoding"
                                                   @change="HandleUpdateSys('is_fix_encoding')"/>
                                        </div>

                                        <div>
                                            <strong class="font-medium text-base-600"> 乱码修复 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                对标题、艺术家、专辑名进行乱码修复.
                                            </p>
                                        </div>
                                    </label>

                                    <label
                                        for="Option3"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="checkbox" class="checkbox size-4 rounded border-gray-300"
                                                   id="Option3" v-model="formData.is_tran_sim"
                                                   @change="HandleUpdateSys('is_tran_sim')"/>
                                        </div>

                                        <div>
                                            <strong class="text-pretty font-medium text-base-600"> 繁体转简体 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                将繁体标题、艺术家、专辑名转换为简体，如本来就是简体，则不会进行转换.
                                            </p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse collapse-arrow bg-base-100 max-w-2xl">
                        <input type="checkbox" v-model="autoModCollapse"/>
                        <div class="collapse-title text-xl font-medium">音乐自动刮削</div>
                        <div class="collapse-content">
                            <div>
                                <div class="space-y-2 max-w-xl">
                                    <label
                                        for="Option4"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="checkbox" class="checkbox size-4 rounded border-gray-300"
                                                   id="Option4" v-model="formData.auto_mod"
                                                   @change="HandleUpdateSys('auto_mod')"/>
                                        </div>

                                        <div>
                                            <strong class="font-medium text-base-600"> 自动刮削 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                可自动从音乐流媒体平台搜索元数据实行刮削操作.
                                            </p>
                                        </div>
                                    </label>
                                    <label
                                        for="Option5"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="checkbox" class="checkbox size-4 rounded border-gray-300"
                                                   id="Option5" v-model="formData.manual_mod"
                                                   @change="HandleUpdateSys('manual_mod')"/>
                                        </div>

                                        <div>
                                            <strong class="font-medium text-base-600"> 手动刮削 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                可自定义修改音乐元数据中的内容，例如：重命名文件、导出歌词文件、导出封面图片等.
                                            </p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="collapse collapse-arrow bg-base-100 max-w-2xl">
                        <input type="checkbox" v-model="tidyCollapse"/>
                        <div class="collapse-title text-xl font-medium flex items-end">
                            音乐文件整理
                            <div class="text-sm ml-1">(必选)</div>
                        </div>
                        <div class="collapse-content">
                            <div>
                                <div class="space-y-2 max-w-xl">
                                    <label
                                        for="Option6"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="radio" name="radio-1"
                                                   class="checkbox size-4 rounded border-gray-300" id="Option6"
                                                   value='tidy' v-model="formData.tidy_music"
                                                   @change="HandleUpdateSys('tidy_music')"/>
                                        </div>

                                        <div>
                                            <strong class="font-medium text-base-600"> 整理文件 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                将文件以规定的格式整理到统一目录下.
                                            </p>
                                        </div>
                                    </label>
                                    <label
                                        for="Option7"
                                        class="flex cursor-pointer items-start gap-4 rounded-lg border border-base-400 p-4 transition hover:bg-gray-50 has-[:checked]:bg-gray-100"
                                    >
                                        <div class="flex items-center">
                                            &#8203;
                                            <input type="radio" name="radio-1"
                                                   class="checkbox size-4 rounded border-gray-300" id="Option7"
                                                   checked="checked" value='move' v-model="formData.tidy_music"
                                                   @change="HandleUpdateSys('tidy_music')"/>
                                        </div>

                                        <div>
                                            <strong class="font-medium text-base-600"> 转移文件 </strong>

                                            <p class="mt-1 text-pretty text-sm text-gray-700">
                                                将文件以源目录层级转移到固定completed或failed目录下.
                                            </p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drawer drawer-end">
                        <input id="auto-mod" type="checkbox" class="drawer-toggle" v-model="isOpenAutoMod"/>
                        <div class="drawer-content">
                        </div>
                        <div class="drawer-side">
                            <label for="auto-mod" aria-label="close sidebar" class="drawer-overlay"></label>
                            <div class="bg-base-100 text-base-content min-h-full w-80 md:w-96 p-4" v-if="isOpenAutoMod">
                                <div>
                                    <div class="mb-4">
                                        <p class="text-gray-400">根据元数据中的标题、艺术家、专辑和文件名、文件完整路径进行匹配。</p>
                                        <p class="text-gray-400 mb-2">标题、艺术家、专辑每一项匹配等级指标：完全一致，包含，不匹配</p>
                                        <div class="form-control w-24">
                                            <label class="label cursor-pointer">
                                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-red-500"
                                                       value="simple" v-model="formData.silent_select_mode" @change="HandleUpdateSys('silent_select_mode')" />
                                                <span class="label-text tooltip tooltip-right"
                                                      data-tip="至少存在一个完全一致和一个包含，但也优先选完全一致">宽松模式</span>
                                            </label>
                                        </div>
                                        <div class="form-control w-24">
                                            <label class="label cursor-pointer">
                                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-blue-500"
                                                       value="normal" v-model="formData.silent_select_mode" @change="HandleUpdateSys('silent_select_mode')"/>
                                                <span class="label-text tooltip tooltip-right"
                                                      data-tip="三个指标必须为包含或完全一致，但也优先选完全一致">标准模式</span>
                                            </label>
                                        </div>
                                        <div class="form-control w-24">
                                            <label class="label cursor-pointer">
                                                <input type="radio" name="radio-auto-mode" class="radio checked:bg-blue-500"
                                                       value="hard" v-model="formData.silent_select_mode" @change="HandleUpdateSys('silent_select_mode')"/>
                                                <span class="label-text tooltip tooltip-right" data-tip="三个指标必须都为完全一致">严格模式</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="mt-2">音乐源顺序:</div>
                                    <multi-select :options="resourceListBatch" v-model="formData.silence_source_list" @change="HandleUpdateSys('silence_source_list')">
                                    </multi-select>
                                    <div class="mt-2">修改范围:</div>
                                    <multi-select :options="modifyListBatch" v-model="formData.silence_modify_list" @change="HandleUpdateSys('silence_modify_list')">
                                    </multi-select>
                                    <div class="mb-4">
                                        <div class="mt-2">原有音乐标签将被保留，不会被修改或覆盖:</div>
                                        <div class="flex items-center">
                                            <input type="checkbox" class="toggle toggle-primary mr-2"
                                                   @change="HandleUpdateSys('silence_is_skip_tag')"
                                                   v-model="formData.silence_is_skip_tag"/>
                                            <div v-if="formData.silence_is_skip_tag">是</div>
                                            <div v-else>否</div>
                                        </div>
                                        <div class="text-gray-400">如修改范围中元数据都存在，则跳过匹配</div>
                                    </div>
                                    <div class="mb-4">
                                        <div class="mt-2">同目录解释为同一个专辑:</div>
                                        <div class="flex items-center">
                                            <input type="checkbox" class="toggle toggle-primary mr-2"
                                                   @change="HandleUpdateSys('silence_is_folder_album')"
                                                   v-model="formData.silence_is_folder_album"/>
                                            <div v-if="formData.silence_is_folder_album">是</div>
                                            <div v-else>否</div>
                                        </div>
                                        <div class="text-gray-400">当元数据中不存在专辑信息，用于补充专辑信息，提高匹配度</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drawer drawer-end">
                        <input id="manual-mod" type="checkbox" class="drawer-toggle" v-model="isOpenManualMod"/>
                        <div class="drawer-content">
                        </div>
                        <div class="drawer-side">
                            <label for="manual-mod" aria-label="close sidebar" class="drawer-overlay"></label>
                            <div class="menu bg-base-100 text-base-content min-h-full w-80 md:w-96 p-4"
                                 v-if="isOpenManualMod">
                                <button class="btn btn-neutral btn-sm" @click="handleSaveManualMusic">保存并关闭</button>
                                <music-meta-data :music-info="formData.silence_music_info" :reload-img="reloadImg"
                                                 :drawer-mode="'drawer'" :mode="'form'">
                                </music-meta-data>
                            </div>
                        </div>
                    </div>
                    <div class="drawer drawer-end">
                        <input id="tidy-music" type="checkbox" class="drawer-toggle" v-model="isOpenTidyMusic"/>
                        <div class="drawer-content">
                        </div>
                        <div class="drawer-side">
                            <label for="tidy-music" aria-label="close sidebar" class="drawer-overlay"></label>
                            <div class="menu bg-base-100 text-base-content min-h-full w-80 p-4" v-if="isOpenTidyMusic">
                                <div class="mb-4">
                                    <div class="pl-4">
                                        <p>整理文件夹，按一级目录，二级目录选定的信息分类</p>
                                        <div>整理后的根目录</div>
                                        <div class="input-demo">
                                            <input type="text" placeholder="Type here"
                                                   class="input input-sm input-bordered w-full max-w-xs"
                                                   v-model="formData.root_path" @change="HandleUpdateSys('root_path')"/>
                                        </div>
                                        <div v-for="(input, index) in formData.dir_list" :key="index"
                                             style="margin-top: 10px;">
                                            <div>第{{ index + 1 }}层目录</div>
                                            <div class="flex">
                                                <single-select v-model="input.value"
                                                               :options="tidyList"
                                                               :placeholder="'请选择'"
                                                               @change="HandleUpdateSys('dir_list')"
                                                >
                                                </single-select>
                                                <button class="btn btn-sm ml-1" @click="removeInput(index)">x</button>

                                            </div>
                                            <div v-if="input.value === 'custom'">
                                                <div>自定义变量：</div>
                                                <input type="text" placeholder="请输入自定义变量，例如：${artist}-${album}"
                                                       class="input input-sm input-bordered w-full max-w-xs" v-model="input.value2" @change="HandleUpdateSys('dir_list')"/>
                                            </div>
                                        </div>
                                        <button class="btn btn-sm mt-2" @click="addInput">添加目录</button>
                                    </div>
                                    <div class="text-gray-400 text-sm">刮削后将成功匹配的文件整理转移到其他目录下。</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 3">
                    <div class="mb-4 font-medium">扩展功能：</div>
                    <div class="flex flex-wrap">
                        <div class="mb-4 w-1/2">
                            <div class="mb-1">停止所有后台任务:</div>
                            <div class="mb-1">
                                <button class="btn" @click="handleTask1">停止后台任务</button>
                            </div>
                            <div class="text-gray-400 text-sm">遇到不执行任务时强制停止所有后台任务后重新执行。</div>
                        </div>
                        <div class="mb-4 w-1/2">
                            <div class="mb-1">全部刮削艺术家封面:</div>
                            <div class="mb-1">
                                <button class="btn" @click="handleTask3">刮削艺术家</button>
                            </div>
                            <div class="text-gray-400 text-sm">全部刮削艺术家封面，可以在艺术家页面单个修改自定义的封面。</div>
                        </div>
                    </div>
                    <div class="divider">OR</div>
                    <div class="mb-2 font-medium">删除管理：</div>
                    <div>
                        <div class="bg-base-100 flex flex-wrap">
                            <div class="mb-4 w-1/2">
                                <div class="mb-1">删除音乐收藏:</div>
                                <div class="mb-1">
                                    <button class="btn" @click="handleTask2('music')">清空音乐收藏</button>
                                </div>
                                <div class="text-gray-400 text-sm">删除数据库中的数据，方便调试重新导入。</div>
                            </div>
                            <div class="mb-4 w-1/2">
                                <div class="mb-1">删除操作记录:</div>
                                <div class="mb-1">
                                    <button class="btn" @click="handleTask2('audit_log')">删除操作记录</button>
                                </div>
                                <div class="text-gray-400 text-sm">删除所有操作记录。</div>
                            </div>
                            <div class="mb-4 w-1/2">
                                <div class="mb-1">删除所有播放记录:</div>
                                <div class="mb-1">
                                    <button class="btn" @click="handleTask2('play_log')">删除播放记录</button>
                                </div>
                                <div class="text-gray-400 text-sm">删除首页播放记录。</div>
                            </div>
                            <div class="mb-4 w-1/2">
                                <div class="mb-1">删除所有刮削记录:</div>
                                <div class="mb-1">
                                    <button class="btn" @click="handleTask2('tag_log')">删除刮削记录</button>
                                </div>
                                <div class="text-gray-400 text-sm">删除所有刮削记录，刮削记录用于标记每个音乐的刮削状态。</div>
                            </div>
                            <div class="mb-4 w-1/2">
                                <div class="mb-1">删除不存在的音乐收藏:</div>
                                <div class="mb-1">
                                    <button class="btn" @click="handleTask2('remove_track_null')">删除不存在</button>
                                </div>
                                <div class="text-gray-400 text-sm">在数据库中同步删除不存在或已被删除的音乐。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 4">
                    <div class="font-medium">接入小爱音箱播放本地音乐</div>
                    <div class="flex flex-wrap">
                        <div class="mt-4 w-1/2 pr-1">
                            <div>小米ID</div>
                            <input type="text" placeholder="请输入账号" class="input input-sm input-bordered w-full max-w-xs"
                                   autocomplete="new-password"
                                   v-model="formData.mi_user_id" @change="HandleUpdateSys('mi_user_id')"/>
                            <div class="text-gray-400 text-sm">小米账号ID非手机号</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>账号密码</div>
                            <input type="password" placeholder="请输入密码"
                                   autocomplete="new-password"
                                   class="input input-sm input-bordered w-full max-w-xs"
                                   v-model="formData.mi_password" @change="HandleUpdateSys('mi_password')"/>
                            <div class="text-gray-400 text-sm">小米账号密码</div>
                        </div>
                        <div class="w-full flex items-center mt-2">
                            <div>音箱设备</div>
                            <button class="btn btn-sm ml-2" @click="handleSearchService">查找</button>
                        </div>
                        <div class="w-full flex">
                            <div class="overflow-x-auto shadow-sm rounded-xl">
                                <table class="table">
                                    <!-- head -->
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>设备名称</th>
                                        <th>设备型号</th>
                                        <th>开启状态</th>
                                        <th>操作</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <!-- row 1 -->
                                    <tr v-for="(item, index) in formData.device_list" :key="index">
                                        <th>{{ index + 1 }}</th>
                                        <td>
                                            <input type="text" placeholder="请输入名称"
                                                   class="input input-sm input-bordered w-full max-w-xs"
                                                   v-model="item.name" @change="HandleUpdateSys('device_list')"/>
                                        </td>
                                        <td>
                                            <input type="text" placeholder="请输入型号"
                                                   class="input input-sm input-bordered w-full max-w-xs"
                                                   v-model="item.type" @change="HandleUpdateSys('device_list')"/>
                                        </td>
                                        <td>
                                            <input type="checkbox" class="toggle toggle-sm" v-model="item.active"
                                                   @change="HandleUpdateSys('device_list')"/>
                                        </td>
                                        <td>
                                            <button class="btn btn-xs mr-1 btn-neutral" @click="addDevice">+</button>
                                            <button class="btn btn-xs" @click="removeDevice(index)">-</button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="mt-4 w-1/2 pr-1">
                            <div>播放本地音乐口令</div>
                            <input type="text" placeholder="请输入关键字"
                                   class="input input-sm input-bordered w-full max-w-xs"
                                   v-model="formData.mi_keyword" @change="HandleUpdateSys('mi_keyword')"/>
                            <div class="text-gray-400 text-sm">识别的播放的关键字，例如关键字：请播放，呼唤语句：小爱同学 请播放 歌曲名/播放列表。</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>对话间隔时间</div>
                            <input type="text" placeholder="请输入" class="input input-sm input-bordered w-full max-w-xs"
                                   v-model="formData.mi_timeloop" @change="HandleUpdateSys('mi_timeloop')"/>
                            <div class="text-gray-400 text-sm">系统会每隔x秒查询小爱音箱对话记录，确保快速响应同时不占用太多资源，建议：5</div>
                        </div>
                        <div class="mt-4 w-1/2 pr-1">
                            <div>内网地址和端口</div>
                            <input type="text" placeholder="请输入内网地址和端口"
                                   class="input input-sm input-bordered w-full max-w-xs"
                                   v-model="formData.inner_ip" @change="HandleUpdateSys('inner_ip')"/>
                            <div class="text-gray-400 text-sm">本项目的内网地址和端口号， 例如：192.168.0.115:8002</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>语音唤醒启用</div>
                            <input type="checkbox" class="toggle"
                                   v-model="formData.mi_open" @change="HandleUpdateSys('mi_open')"/>
                            <div class="text-gray-400 text-sm">启动后才可以通过语音唤醒控制音乐，不用时关闭较好，避免有封号风险</div>
                        </div>
                        <div class="mt-4 w-1/2">
                            <div>播放列表按钮</div>
                            <input type="checkbox" class="toggle"
                                   v-model="formData.mi_play_in_pl" @change="HandleUpdateSys('mi_play_in_pl')"/>
                            <div class="text-gray-400 text-sm">启动后音乐收藏-播放列表中会出现小爱音箱播放按钮, 此方法可不启用语音唤醒, 避免频繁调用接口服务</div>
                        </div>
                        <div class="mt-4 w-full flex">
                            <button class="btn btn-sm btn-neutral mr-2" onclick="test_link.showModal()">测试连接</button>
                            <button class="btn btn-sm mr-2" onclick="test_play.showModal()">测试播放</button>
                            <button class="btn btn-sm btn-accent text-accent-content mr-2" @click="handleTestSpeek">测试点播</button>
                            <button class="btn btn-sm" @click="handleTask2('remove_mi_playlist')">清空播放</button>
                        </div>
                        <div class="mt-1">
                            <div class="text-gray-400 text-sm">测试连接：连接成功小爱会发出声音提示成功</div>
                            <div class="text-gray-400 text-sm">测试播放：小爱会随机播放一首音乐测试</div>
                        </div>
                    </div>
                    <div class="drawer">
                        <input id="search-device" type="checkbox" class="drawer-toggle" v-model="search_device"/>
                        <div class="drawer-content">
                        </div>
                        <div class="drawer-side">
                            <label for="search-device" aria-label="close sidebar" class="drawer-overlay"></label>
                            <div class="p-4 w-80 min-h-full bg-base-200 text-base-content w-80 md:w-96">
                                <span class="loading loading-infinity loading-lg" v-if="isLoading"></span>
                                <div class="bg-base-100" v-else>
                                    <table class="table">
                                        <!-- head -->
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>设备名称</th>
                                            <th>模型</th>
                                            <th>操作</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <!-- row 1 -->
                                        <tr v-for="(item,index) in deviceList" :key="index">
                                            <th>{{ index + 1 }}</th>
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.hardware }}</td>
                                            <td>
                                                <button class="btn btn-xs mr-1" @click="addDeviceItem(item)">+</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 5">
                    <div class="mt-2">
                        <div class="font-medium">网盘音乐管理</div>
                        <div class="mb-4 mt-2">
                            <div class="badge badge-outline mb-1 cursor-pointer" @click="redirctEditDetail('/app/webdav/')">/app/webdav</div>
                            <div class="text-gray-400 text-sm">本地挂载模式需要挂载映射到这个目录，直连模式不需要挂载可直接在这个目录查看。</div>
                        </div>
                        <div class="w-24 mt-2">
                            <div class="form-control">
                                <label class="label cursor-pointer flex items-center">
                                    <input type="radio" name="radio-10" class="radio checked:bg-neutral" value="direct"
                                           v-model="formData.alist_mode" @change="HandleUpdateSys('alist_mode')"/>
                                    <span class="label-text">直连模式</span>
                                </label>
                            </div>
                            <div class="form-control">
                                <label class="label cursor-pointer flex items-center">
                                    <input type="radio" name="radio-10" class="radio checked:bg-accent" value="local"
                                           v-model="formData.alist_mode" @change="HandleUpdateSys('alist_mode')"/>
                                    <span class="label-text">本地挂载</span>
                                </label>
                            </div>
                        </div>
                        <div v-if="formData.alist_mode === 'direct'">
                            <div class="flex flex-wrap">
                                <div class="mt-2 w-1/2">
                                    <div>AList Url</div>
                                    <input type="text" placeholder="请输入 alist 的 url"
                                           @change="HandleUpdateSys('alist_url')"
                                           v-model="formData.alist_url"
                                           class="input input-sm input-bordered w-full max-w-xs"/>
                                    <div class="text-gray-400 text-sm">确保该系统可以访问到 alist
                                        地址，例如：http://192.168.0.115:5244
                                    </div>
                                </div>
                                <div class="mt-2 w-1/2">
                                    <div>根目录</div>
                                    <input type="text" placeholder="请输入 alist 的 根目录"
                                           @change="HandleUpdateSys('alist_root_path')"
                                           v-model="formData.alist_root_path"
                                           class="input input-sm input-bordered w-full max-w-xs"/>
                                    <div class="text-gray-400 text-sm">alist根目录地址,例如：/aliyun/音乐</div>
                                </div>
                            </div>
                            <div class="flex flex-wrap">
                                <div class="mt-4 w-1/2 pr-1">
                                    <div>用户名</div>
                                    <input type="text" placeholder="请输入账号"
                                           class="input input-sm input-bordered w-full max-w-xs"
                                           v-model="formData.alist_username"
                                           @change="HandleUpdateSys('alist_username')"/>
                                    <div class="text-gray-400 text-sm">AList 的用户名</div>
                                </div>
                                <div class="mt-4 w-1/2">
                                    <div>账号密码</div>
                                    <input type="password" placeholder="请输入密码"
                                           class="input input-sm input-bordered w-full max-w-xs"
                                           v-model="formData.alist_password"
                                           @change="HandleUpdateSys('alist_password')"/>
                                    <div class="text-gray-400 text-sm">AList账号密码</div>
                                </div>
                            </div>
                            <div class="mt-2">显示条数</div>
                            <input type="text" placeholder="请输入显示的条数"
                                   @change="HandleUpdateSys('alist_page_size')"
                                   v-model="formData.alist_page_size"
                                   class="input input-sm input-bordered w-full max-w-xs"/>
                            <div class="text-gray-400 text-sm">限制每个目录显示的条数</div>
                            <div class="mt-2">
                                <button class="btn btn-sm" @click="handleTask2('clear_webdav_cache')">清除缓存</button>
                                <div class="text-gray-400 text-sm">清除缓存的元数据文件</div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="flex flex-wrap">
                                <div class="mt-2 w-1/2">
                                    <div>AList Url</div>
                                    <input type="text" placeholder="请输入 alist 的 url"
                                           @change="HandleUpdateSys('alist_url')"
                                           v-model="formData.alist_url"
                                           class="input input-sm input-bordered w-full max-w-xs"/>
                                    <div class="text-gray-400 text-sm">确保该系统可以访问到 alist
                                        地址，例如：http://192.168.0.115:5244
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 6">
                    <div class="mt-2">
                        <div class="font-medium mb-2">系统信息</div>
                        <div class="flex mb-1">
                            <div>系统版本:</div>
                            <div class="text-gray-500 ml-2">
                                <span>{{ versionNum }}</span>
                            </div>
                        </div>
                        <div class="flex mb-1">
                            <div>更新时间:</div>
                            <div class="text-gray-500 ml-2">
                                <span>{{ version }}</span>
                            </div>
                        </div>
                        <div class="flex mb-1">
                            <div>激活码:</div>
                            <div>
                                <span class="text-gray-500 ml-2 badge cursor-pointer" v-bk-copy="sysInfo.raw_code">******</span>
                            </div>
                        </div>
                        <div class="flex mb-1">
                            <div>激活服务器:</div>
                            <div class="text-gray-500">
                                <span class="badge ml-2 text-gray-500">{{ sysInfo.code_server_status }}</span>
                            </div>
                        </div>
                        <div class="flex mb-1">
                            <div>数据库:</div>
                            <div>
                                <span class="badge ml-2 text-gray-500">{{ sysInfo.database_name }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-2">
                        <div>ffmpeg版本:</div>
                        <div class="text-gray-500">
                            <span class="badge ml-2 text-gray-500">{{ sysInfo.ffmpeg_version }}</span>
                        </div>
                    </div>
                    <div class="flex mb-2">
                        <div>服务器用户:</div>
                        <div class="text-gray-500">
                            <span class="badge ml-2 text-gray-500">{{ sysInfo.linux_user_id }}</span>
                        </div>
                    </div>
                    <div class="flex mb-2">
                        <div>服务器架构:</div>
                        <div class="text-gray-500">
                            <span class="badge ml-2 text-gray-500">{{ sysInfo.linux_uname }}</span>
                        </div>
                    </div>
                    <div class="flex mb-2">
                        <div>Media文件夹权限:</div>
                        <div class="text-gray-500">
                            <span class="badge ml-2 text-gray-500">{{ sysInfo.media_permission }}</span>
                        </div>
                    </div>
                    <div class="mt-4">
                        <div>服务进程</div>
                        <div class="overflow-x-auto">
                            <table class="table">
                                <!-- head -->
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>进程</th>
                                    <th>名称</th>
                                    <th>状态</th>
                                    <th>运行时间</th>
                                    <th>操作</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in sysInfo.process_info" :key="index">
                                    <th>{{ index + 1 }}</th>
                                    <td>{{ item.pid_name }}</td>
                                    <td>{{ item.name }}</td>
                                    <td class="flex items-center">
                                        <span class="loading loading-ball loading-md"
                                              v-if="item.state_name ==='正在运行'"></span>
                                        {{ item.state_name }}
                                    </td>
                                    <td>{{ item.description }}</td>
                                    <td>
                                        <a class="link mr-1" v-if="item.state_name !=='正在运行'"
                                           @click="controlSupervisor('start',item.pid_name, item.group )">启动</a>
                                        <a class="link link-error mr-1" v-if="canStop(item)"
                                           @click="controlSupervisor('stop',item.pid_name, item.group )">停止</a>
                                        <a class="link mr-1"
                                           @click="controlSupervisor('restart',item.pid_name, item.group )">重启</a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-else-if="activeIndex === 7">
                    <div class="mt-2">
                            <div class="font-medium mb-2">认证管理</div>
                            <label class="label">
                                <span class="label-text">Access Token</span>
                            </label>
                            <div class="flex items-center gap-4">
                                <div class="form-control w-96">
                                    <input type="text"  v-model="formData.access_token" class="input input-bordered input-sm" @change="HandleUpdateSys('access_token')"/>
                                </div>
                                <div class="space-x-2">
                                    <button class="btn btn-sm btn-primary" @click="generateToken">生成新Token</button>
                                    <button class="btn btn-sm" @click="copyToken">复制</button>
                                </div>
                            </div>
                            <div class="text-sm text-gray-500 mt-4 space-y-1">
                                <div>• Token 用于 API 认证，请在请求头中携带</div>
                                <div>• 生成新Token会立即使旧Token失效</div>
                                <div>• 请妥善保管Token，不要泄露给他人</div>
                            </div>
                    </div>
                    <div class="mt-4">
                        <div class="font-medium">开放 API</div>
                        <div class="overflow-x-auto mt-4">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>API 名称</th>
                                        <th>功能描述</th>
                                        <th>请求方式</th>
                                        <th>认证方式</th>
                                        <th>状态</th>
                                        <th>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(api, index) in apiList">
                                        <tr>
                                            <td>{{ api.name }}</td>
                                            <td>{{ api.description }}</td>
                                            <td>{{ api.method }}</td>
                                            <td>{{ api.auth_type }}</td>
                                            <td>
                                                <div class="badge" :class="api.status === 'normal' ? 'badge-success' : 'badge-error'">
                                                    {{ api.status === 'normal' ? '正常' : '异常' }}
                                                </div>
                                            </td>
                                            <td>
                                                <button class="btn btn-xs" @click="toggleParams(api)">
                                                    {{ api.show ? '收起' : '文档' }}
                                                </button>
                                            </td>
                                        </tr>
                                        <tr v-if="api.show">
                                            <td colspan="6">
                                                <div class="p-4 bg-base-200 rounded-lg">
                                                    <div class="mb-4">
                                                        <div class="font-medium mb-2">接口地址</div>
                                                        <div class="text-sm">{{ api.endpoint }}</div>
                                                    </div>
                                                    <div class="mb-4">
                                                        <div class="font-medium mb-2">请求头</div>
                                                        <div class="text-sm">
                                                            <div v-for="(value, key) in api.headers" :key="key">
                                                                {{ key }}: {{ value }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mb-4">
                                                        <div class="font-medium mb-2">请求参数</div>
                                                        <div class="text-sm">
                                                            <div v-for="(param, pIndex) in api.params" :key="pIndex">
                                                                <span class="font-medium">{{ param.name }}</span>
                                                                <span class="ml-2">({{ param.type }})</span>
                                                                <span class="ml-2 text-gray-500">{{ param.description }}</span>
                                                                <span v-if="param.required" class="text-red-500 ml-2">必填</span>
                                                            </div>
                                                            <div v-if="api.params.length === 0">无</div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="font-medium mb-2">返回示例</div>
                                                        <div class="text-sm">
                                                            <pre class="whitespace-pre-wrap">{{ api.response_example }}</pre>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dialog id="test_link" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">测试连接</h3>
                <div class="py-4 z-20">
                    测试小爱同学同学语音连接
                    <input
                        type="text"
                        placeholder="Type here"
                        v-model="testLinkText"
                        class="input input-bordered input-sm w-full max-w-xs"/>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="linkTest">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="test_play" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">测试播放</h3>
                <div class="py-4 z-20">
                    测试小爱同学播放本地音乐
                    <div class="w-72" ref="selectContainer">
                        <input type="text" ref="inputVal" class="input input-bordered input-sm w-full max-w-xs"
                               placeholder="搜索歌曲关键词" v-model="searchTerm" @input="handleInput"
                               autocomplete="new-password">
                        </input>
                        <ul class="absolute w-full bg-base-100 border border-base-100 rounded-md mt-2 shadow-lg"
                            v-if="showResults">
                            <div v-if="suggestions.tracks.length > 0">
                                <li class="ml-2 mt-2">歌曲</li>
                                <li v-for="(track, index) in suggestions.tracks" :key="'tr' + index"
                                    class="py-2 px-4 cursor-pointer hover:bg-gray-100 hover:rounded-lg"
                                    @click="selectTrack(track)">
                                    <div :key="'tra' + index" class="text-sm font-light">
                                        {{ track.title }} - {{ track.year }} - {{ track.artist }} - {{
                                            track.album
                                        }}
                                    </div>
                                </li>
                            </div>
                        </ul>
                    </div>
                    <div class="text-gray-400 text-sm mt-1">提示：部分机型只支持mp3格式播放</div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="linkPlay">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog id="test_speek" class="modal modal-bottom sm:modal-middle" ref="test_speek">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">测试语音唤醒点播</h3>
                <div class="py-4 z-20">
                    <div class="text-gray-400">请说出下面的文字进行唤醒点播</div>
                    <div class="flex items-center justify-start text-xl my-2">
                        <span class="loading loading-ring loading-md"></span>
                        <div class="ml-2">小爱同学,</div>
                        <div class="ml-2">{{ formData.mi_keyword }},</div>
                        <div class="ml-2">"""歌曲名称"""</div>
                    </div>
                    <div class="text-gray-400 text-sm mt-1">提示：歌曲名称/播放列表必须是音乐收藏里存在的</div>
                    <div class="text-gray-400 text-sm mt-1">提示：等待识别时间{{ formData.mi_timeloop }}秒</div>
                    <div class="text-gray-400 text-sm mt-1">提示：部分型号只支持mp3格式播放</div>
                    <div v-for="(item, index) in miLog" :key="'mi' + index">
                        <div class="chat chat-start" v-if="item.role==='user'">
                            <div class="chat-image avatar">
                                <div class="w-10 rounded-full">
                                    <img
                                        alt=""
                                        src="/static/dist/img/avator.webp"/>
                                </div>
                            </div>
                            <div class="chat-header">
                                {{ item.role }}
                                <time class="text-xs opacity-50">{{ item.time }}</time>
                            </div>
                            <div class="chat-bubble">{{ item.content }}</div>
                        </div>
                        <div class="chat chat-end" v-else>
                            <div class="chat-image avatar">
                                <div class="w-10 rounded-full">
                                    <img
                                        alt="Tailwind CSS chat bubble component"
                                        src="/static/dist/img/avator.webp"/>
                                </div>
                            </div>
                            <div class="chat-header">
                                {{ item.role }}
                                <time class="text-xs opacity-50">{{ item.time }}</time>
                            </div>
                            <div class="chat-bubble">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-sm" @click="setTimerNull">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
        <dialog ref="import_config" id="import_config" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">导入配置</h3>
                <div class="py-4 z-20">
                    <input type="file" class="file-input file-input-bordered file-input-sm w-full max-w-xs" @change="onFileChange"/>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleImportConfig">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>
<script>
import MusicMetaData from '@/views/home/musicMetaData'
import SingleSelect from "@/components/iview/SingleSelect";
import MultiSelect from "@/components/iview/MultiSelect";

export default {
    components: {
        SingleSelect,
        MusicMetaData,
        MultiSelect
    },
    data() {
        return {
            parentValue: 'title',
            size: 'small',
            activeIndex: 1,
            test: '',
            data: [],
            pagination: {
                current: 1,
                count: 500,
                limit: 15
            },
            suggestions: {},
            modifyList: '',
            modifyListBatch: [
                {id: 'artist', name: '艺术家'},
                {id: 'album', name: '专辑'},
                {id: 'albumartist', name: '专辑艺术家'},
                {id: 'album_img', name: '专辑封面'},
                {id: 'year', name: '年份'},
                {id: 'lyrics', name: '歌词'},
                {id: 'is_save_lyrics_file', name: '歌词(LRC文件)'},
                {id: 'discnumber', name: '光盘编号'},
                {id: 'tracknumber', name: '音轨号'},
                {id: 'composer', name: '作曲家'},
                {id: 'lyricist', name: '作词家'}
            ],
            formData: {
                'silence_music_info': {},
                'access_token': ''
            },
            saveInMetaData: true,
            saveInDB: false,
            roleList: [],
            tidyList: [
                {id: 'title', name: '标题'},
                {id: 'artist', name: '艺术家'},
                {id: 'album', name: '专辑'},
                {id: 'album_artist', name: '专辑艺术家'},
                {id: 'album_type', name: '专辑类型'},
                {id: 'genre', name: '风格'},
                {id: 'language', name: '语言'},
                {id: 'track_number', name: '音轨号'},
                {id: 'disc_number', name: '光盘编号'},
                {id: 'comment', name: '描述'},
                {id: 'custom', name: '自定义'}
            ],
            resourceListBatch: [
                {id: 'netease', name: '网易云音乐'},
                {id: 'migu', name: '咪咕音乐'},
                {id: 'qmusic', name: 'QQ音乐'},
                {id: 'kugou', name: '酷狗音乐'},
                {id: 'kuwo', name: '酷我音乐'},
                { id: 'itunes', name: 'iTunes' },
                { id: 'spotify', name: 'Spotify' },
            ],
            search_device: false,
            isLoading: false,
            deviceList: [],
            preDataCollapse: true,
            autoModCollapse: true,
            tidyCollapse: true,
            isOpenAutoMod: false,
            isOpenManualMod: false,
            isOpenTidyMusic: false,
            reloadImg: false,
            sysInfo: {},
            testLinkText: '你好，我是小爱',
            searchTerm: '',
            showResults: false,
            showHelpDownload: false,
            timer: null,
            miLog: '',
            pwdType: 'text',
            showParams: {
                search: false,
                play: false
            },
            apiList: [],
        }
    },
    created() {
        this.fetchSysDict()
    },
    computed: {
        version() {
            return window.projectVersion
        },
        versionNum() {
            return window.projectVersionNum
        },
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
        this.setTimerNull()
    },
    methods: {
        canStop(item) {
            // 检查 state_name 和 pid_name 的值
            return (item.state_name !== '已停止' && item.pid_name !== 'gunicorn' && item.pid_name !== 'nginx')
        },
        fetchSysInfo() {
            this.$api.Task.getSysInfo().then((res) => {
                if (res.result) {
                    this.sysInfo = res.data
                }
            })
        },
        handleActive(index) {
            this.activeIndex = index
            if (index === 6) {
                this.fetchSysInfo()
            } else if (index === 7) {
                this.fetchOpenApi()
            }
        },
        fetchSysDict() {
            this.$api.Task.getSysDict().then((res) => {
                if (res.result) {
                    this.formData = res.data
                }
            })
        },
        HandleUpdateSys(key) {
            console.log(key)
            let value = this.formData[key]
            if (value.constructor === Boolean) {
                value = value ? '1' : '0'
            }
            if (key === 'silence_modify_list' || key === 'silence_source_list') {
                value = value.join(',')
            } else if (key === 'dir_list') {
                value = JSON.stringify(value)
            } else if (key === 'device_list' || key === 'silence_music_info') {
                value = JSON.stringify(value)
            } else if (key === 'auto_mod') {
                if (value === '1') {
                    this.isOpenAutoMod = true
                }
            } else if (key === 'manual_mod') {
                if (value === '1') {
                    this.isOpenManualMod = true
                }
            } else if (key === 'tidy_music') {
                if (value === 'tidy') {
                    this.isOpenTidyMusic = true
                }
            } else if (key === 'mi_play_in_pl') {
                window.localStorage.setItem('mi_play_in_pl', value)
            }
            this.$api.Task.UpdateSys({'key': key, value: value}).then((res) => {
                this.$myMsg.notify({
                    title: '修改成功！',
                    type: 'success',
                    time: 1000,
                })
            })
        },
        handleTask1() {
            this.$api.Task.debugTask1().then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        },
        handleTask2(v) {
            this.$api.Task.debugTask2({'mode': v}).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        },
        handleTask3() {
            this.$api.Task.batchAutoUpdateArtist().then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        type: 'success',
                        time: 2000,
                    })
                }
            })
        },
        linkTest() {
            this.$api.Task.miServiceTest({'text': this.testLinkText}).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '测试发送成功！',
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        linkPlay() {
            this.$api.Task.miServicePlay({'text': this.searchTerm}).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '播放发送成功！',
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        addInput() {
            this.formData.dir_list.push({value: ''}) // 添加新的输入框
        },
        removeInput(index) {
            this.formData.dir_list.splice(index, 1) // 删除指定索引的输入框
            this.HandleUpdateSys('dir_list')
        },
        addDevice() {
            this.formData.device_list.push({'name': '', 'type': '', 'active': false})
        },
        addDeviceItem(item) {
            this.formData.device_list.push({'name': item.name, 'type': item.hardware, 'active': false})
        },
        removeDevice(index) {
            if (this.formData.device_list.length === 1) {
                return
            }
            this.formData.device_list.splice(index, 1) // 删除指定索引的输入框
            this.HandleUpdateSys('device_list')

        },
        handleSearchService() {
            this.search_device = true
            this.isLoading = true
            this.$api.Task.miServiceSearch().then((res) => {
                this.isLoading = false
                if (res.result) {
                    this.deviceList = res.data
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        selectSuggestion(key, item) {
            this.formData[key] = this.formData[key].substring(0, this.formData[key].length - 1) + item
            this.HandleUpdateSys(key)
        },
        handleSaveManualMusic() {
            this.isOpenManualMod = false
            this.HandleUpdateSys('silence_music_info')
        },
        handleTest() {
            console.log(123, this.parentValue)
        },
        controlSupervisor(action, name, group) {
            this.$api.Task.supervisorControl({action, name, group}).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '修改成功！',
                        content: res.message,
                        type: 'success',
                        time: 2000,
                    })
                    this.fetchSysInfo()
                }
            })
        },
        HandleOpenLastfm() {
            window.open('https://www.last.fm/api/account/create')
        },
        handleInput() {
            if (this.searchTerm.length > 0) {
                // 发送AJAX请求获取联想结果
                // 假设返回的结果为一个数组，存储在suggestions变量中
                if (this.searchTimeout2) {
                    clearTimeout(this.searchTimeout2)
                }
                this.searchTimeout2 = setTimeout(() => {
                    this.searchTimeout2 = null
                    this.$api.subsonic.search(this.searchTerm).then((res) => {
                        this.suggestions = res
                        this.showResults = true
                    })
                }, 300)
            } else {
                this.suggestions = {}
                this.showResults = false
            }
        },
        selectTrack(track) {
            this.searchTerm = track.title
            this.showResults = false
        },
        handleClickOutside(event) {
            const container = this.$refs.selectContainer
            if (container && !container.contains(event.target)) {
                this.showResults = false
            }
        },
        redirctEditDetail(path) {
            if (this.$route.name !== 'home') {
                this.$router.push({name: 'home'})
            }
            this.$store.commit('setFullPath', path)
        },
        handleTestSpeek() {
            if (!this.formData.mi_open) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请打开"语音唤醒启用"开关！',
                    type: 'error',
                    time: 5000,
                })
                return
            }
            if (this.formData.inner_ip.startsWith('http')) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请正确设置"内网地址和端口"！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            if (!this.formData.mi_keyword || this.formData.inner_ip === '' || this.formData.mi_timeloop === '') {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请正确设置"唤醒词、内网地址和端口、轮询时间"！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            if (this.formData.device_list.length === 0) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请至少选择一个设备！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            const isActivePresent = this.formData.device_list.some(item => item.active === true);
            if (!isActivePresent) {
                this.$myMsg.notify({
                    title: '创建失败！',
                    content: '请至少开启一个设备！',
                    type: 'error',
                    time: 5000,
                })
                return;
            }
            this.$refs['test_speek'].showModal()
            this.handlePolling()
        },
        // 轮询开启
        handlePolling() {
            // 查询接口
            this.fetchMiLog()
            this.timer = setInterval(() => {
                this.fetchMiLog()
            }, 2000)
        },
        setTimerNull() {
            clearInterval(this.timer)
            this.timer = null
        },
        fetchMiLog() {
            this.$api.Task.getRuntimeMiLog().then((res) => {
                if (res.result) {
                    this.miLog = res.data.log
                }
            })
        },
        handleExportConfig() {
            this.$api.Task.exportConfig().then((res) => {
                if (res.result) {
                    window.open(res.data.url)
                }
            })
        },
        handleImportConfig() {
            const formData = new FormData()
            formData.append('file', this.selectedFile)
            this.$api.Task.importConfig(formData).then((res) => {
                if (res.result) {
                    this.$myMsg.notify({
                        title: '导入成功！',
                        type: 'success',
                        time: 2000,
                    })
                    this.$refs["import_config"].close()
                    this.fetchSysDict()
                }
            })
        },
        onFileChange(event) {
            this.selectedFile = event.target.files[0];
        },
        toggleParams(api) {
            api.show = !api.show;
        },
        generateToken() {
            // 前端生成随机 16位字符串
            const token = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            this.formData.access_token = token
            this.HandleUpdateSys('access_token')
        },
        copyToken() {
            navigator.clipboard.writeText(this.formData.access_token)
            this.$myMsg.notify({
                title: '复制成功！',
                type: 'success',
                time: 2000,
            })
        },
        fetchOpenApi() {
            this.$api.Task.openApi().then((res) => {
                if (res.result) {
                    this.apiList = res.data
                }
            })
        }
    }
}
</script>
<style lang="postcss">
.bk-table-header .custom-header-cell {
    color: inherit;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-underline-position: under;

}
</style>
